import angular from 'angular';

import ModalsComponent from './modals.cmpt';
import ComponentModule from './component';

export default angular
    .module('application.component.modals', [
        ComponentModule.name
    ])
    .component(ModalsComponent.selector, ModalsComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/index.js